import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

interface GroupListItemInterface {
  group_id: number;
  name: string;
}

interface GroupListResultInterface {
  error_code: number;
  error_msg: string;
  data: { list: Array<GroupListItemInterface> };
}

interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

const GROUP_LIST_API = '/api/house_group/group_list';
const GET_HOUSE_TYPE_LIST_API = '/api/house_type/all';

@Injectable()
export class SearchGroupAndTypeService {

  constructor(private http: HttpClient) { }

  /**
  * 获取全部房源分组
  */
  getGroupList(): Observable<GroupListResultInterface> {
    return this.http.get(GROUP_LIST_API) as Observable<
      GroupListResultInterface
    >;
  }

  // 获取房型列表
  getHouseTypeList() {
    return this.http.get(
      GET_HOUSE_TYPE_LIST_API
    ) as Observable<IHttpResponse>;
  }
}
